export const SCHEDULE_TASK_ACTIONS = {
    SCHEDULE_TASK_SEARCH: 'SCHEDULE_TASK_SEARCH',
    SCHEDULE_TASK_SEARCH_SUCCESS: 'SCHEDULE_TASK_SEARCH_SUCCESS',
    SCHEDULE_TASK_SEARCH_ERROR: 'SCHEDULE_TASK_SEARCH_ERROR',

    SCHEDULE_TASK_UPSERT: 'SCHEDULE_TASK_UPSERT',
    SCHEDULE_TASK_UPSERT_SUCCESS: 'SCHEDULE_TASK_UPSERT_SUCCESS',
    SCHEDULE_TASK_UPSERT_ERROR: 'SCHEDULE_TASK_UPSERT_ERROR',


    SCHEDULE_TASK_UPLOAD: 'SCHEDULE_TASK_UPLOAD',
    SCHEDULE_TASK_UPLOAD_SUCCESS: 'SCHEDULE_TASK_UPLOAD_SUCCESS',
    SCHEDULE_TASK_UPLOAD_ERROR: 'SCHEDULE_TASK_UPLOAD_ERROR',

    SCHEDULE_TASK_EDIT: 'SCHEDULE_TASK_EDIT',

    SCHEDULE_TASK_RESET: 'SCHEDULE_TASK_RESET',
};

export const scheduleResetAction = () => ({
    type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_RESET,
});

export const scheduleSearchAction = (payload) => ({
    type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH,
    ...payload,
});

export const scheduleEditAction = (payload) => ({
    type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_EDIT,
    ...payload,
});

export const scheduleUpsertAction = (payload) => ({
    type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_UPSERT,
    ...payload,
});
export const scheduleUploadAction = (payload) => ({
    type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_UPLOAD,
    ...payload,
});
export const taskEditAction = (payload) => ({
    type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_EDIT,
    ...payload,
});

export default {
    SCHEDULE_TASK_ACTIONS,
    scheduleSearchAction,
    scheduleUpsertAction,
    scheduleEditAction,
    scheduleUploadAction,
};
